import { defineComponent as f, inject as m, provide as u, computed as a, ref as y, h as t } from "vue";
import { renderArrow as w } from "./ghl-ui.es1038.js";
import h from "./ghl-ui.es1320.js";
import v from "./ghl-ui.es1321.js";
import N from "./ghl-ui.es1322.js";
import b from "./ghl-ui.es1323.js";
import { isSubmenuNode as c, isRenderNode as S, isDividerNode as K, isGroupNode as k } from "./ghl-ui.es1324.js";
import { dropdownInjectionKey as D, dropdownMenuInjectionKey as I } from "./ghl-ui.es962.js";
import { modalBodyInjectionKey as R } from "./ghl-ui.es1019.js";
import { drawerBodyInjectionKey as j } from "./ghl-ui.es954.js";
import { popoverBodyInjectionKey as x } from "./ghl-ui.es1313.js";
import { XScrollbar as B } from "./ghl-ui.es959.js";
const X = f({
  name: "DropdownMenu",
  props: {
    scrollable: Boolean,
    showArrow: Boolean,
    arrowStyle: [String, Object],
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNodes: {
      type: Array,
      default: () => []
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  setup(i) {
    const {
      renderIconRef: o,
      childrenFieldRef: d
    } = m(D);
    u(I, {
      showIconRef: a(() => {
        const r = o.value;
        return i.tmNodes.some((e) => {
          var n;
          if (e.isGroup)
            return (n = e.children) === null || n === void 0 ? void 0 : n.some(({
              rawNode: p
            }) => r ? r(p) : p.icon);
          const {
            rawNode: s
          } = e;
          return r ? r(s) : s.icon;
        });
      }),
      hasSubmenuRef: a(() => {
        const {
          value: r
        } = d;
        return i.tmNodes.some((e) => {
          var n;
          if (e.isGroup)
            return (n = e.children) === null || n === void 0 ? void 0 : n.some(({
              rawNode: p
            }) => c(p, r));
          const {
            rawNode: s
          } = e;
          return c(s, r);
        });
      })
    });
    const l = y(null);
    return u(R, null), u(j, null), u(x, l), {
      bodyRef: l
    };
  },
  render() {
    const {
      parentKey: i,
      clsPrefix: o,
      scrollable: d
    } = this, l = this.tmNodes.map((r) => {
      const {
        rawNode: e
      } = r;
      return e.show === !1 ? null : S(e) ? t(b, {
        tmNode: r,
        key: r.key
      }) : K(e) ? t(h, {
        clsPrefix: o,
        key: r.key
      }) : k(e) ? t(v, {
        clsPrefix: o,
        tmNode: r,
        parentKey: i,
        key: r.key
      }) : t(N, {
        clsPrefix: o,
        tmNode: r,
        parentKey: i,
        key: r.key,
        props: e.props,
        scrollable: d
      });
    });
    return t("div", {
      class: [`${o}-dropdown-menu`, d && `${o}-dropdown-menu--scrollable`],
      ref: "bodyRef"
    }, d ? t(B, {
      contentClass: `${o}-dropdown-menu__content`
    }, {
      default: () => l
    }) : l, this.showArrow ? w({
      clsPrefix: o,
      arrowStyle: this.arrowStyle,
      arrowClass: void 0,
      arrowWrapperClass: void 0,
      arrowWrapperStyle: void 0
    }) : null);
  }
});
export {
  X as default
};
